import * as Sentry from '@sentry/react';
import { type Action } from 'redux-saga';
import { createInjectable } from '@team/saga-kit';
import { ReduxKit } from '@team/redux';
import { sagaManager } from '../store';

const reporter = createInjectable({
  manager: sagaManager,
  name: 'error:reporter',
  worker: function (action: Action) {
    if (ReduxKit.isPayloadAction(action)) {
      Sentry.captureException(action.payload);

      return;
    }

    Sentry.captureException(action);
  },
});

export { reporter as errorReporter };
